import { Card, Col, Input, Row, Tabs } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SearchIcon from "../../../../Icons/SearchIcon";
import { css } from "@emotion/css";
import TickIcon from "../../../../Icons/TickIcon";
import Courthouse from "../../../../Theme/CustomIcons/Icons/Building/Courthouse";
import EntityParentLayout from "../OrgSettings/Entity/EntityParentLayout";
import PeopleIcon from "../../../../Theme/CustomIcons/Icons/Users/PeopleIcon";
import UsersDropdown, { getSelectedUserComponent } from "./UsersDropdown";
import OrganizationModules from "../OrgSettings/Modules/OrganizationModules";
import CustomGridIcon from "../../../../Theme/CustomIcons/Icons/CustomIcons/CustomGridIcon";

function AllSettings() {
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const themeDefault = useSelector((state) => state.themeDefault);
  const { sharedUserInfo } = sharedLogin;
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const roleFeatures = sharedUserInfo?.userAccess || [];
  let industry = [];
  if (sharedUserInfo?.payload?.company) {
    industry =
      sharedUserInfo?.payload?.company?.modules?.length > 0
        ? sharedUserInfo?.payload?.company?.modules
        : [];
  } else if (sharedUserInfo?.empCompanies?.length > 0) {
    industry =
      sharedUserInfo?.empCompanies[0]?.companyId?.modules?.length > 0
        ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
        : [];
  }

  // Placeholder tabs until we wire real settingTabs
  const settingTabs = {
    Entity: [
      {
        key: "Entity",
        label: "Entity",
        children: <EntityParentLayout />,
        show: true,
      },
    ],
    Modules: [
      {
        key: "Modules",
        label: "Modules",
        children: <OrganizationModules />,
        show: true,
      },
    ],
    Users: [],
  };

  const [search, setSearch] = useState("");
  const allTabs = settingTabs;
  const [selectedSetting, setSelectedSetting] = useState(
    Object.keys(allTabs)[0] || ""
  );
  const [selectedUserType, setSelectedUserType] = useState("ActiveUsers");
  const selected = allTabs[selectedSetting];
  const itemsToRender = (selected || []).filter(
    (item) => item?.show && item?.children && item?.label
  );
  return (
    <Row gutter={[16, 16]}>
      <Col span={6}>
        <Card
          title={
            <Input
              placeholder="Search Settings"
              variant="borderless"
              addonAfter={<SearchIcon />}
              onChange={(e) => setSearch(e?.target?.value || "")}
            />
          }
          style={{ display: "flex", flexDirection: "column", gap: "8px" }}
        >
          {Object.keys(allTabs).map((e) => {
            return (
              (!search || e?.toLocaleLowerCase()?.includes(search)) &&
              (e === "Users" ? (
                <UsersDropdown
                  key={e}
                  selectedSetting={selectedSetting}
                  setSelectedSetting={setSelectedSetting}
                  selectedUserType={selectedUserType}
                  setSelectedUserType={setSelectedUserType}
                />
              ) : (
                <p
                  className={css`
                    transition: 0.3s;
                    padding: 10px 12px;
                    width: 100%;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 10px;
                    font-size: ${themeDefault?.info?.newConfig?.titleFontSize};
                    border-radius: ${themeDefault?.info?.borderRadius}px;
                    background: ${selectedSetting === e
                      ? themeDefault?.info?.colorPrimary
                      : "transparent"};
                    color: ${selectedSetting === e
                      ? themeDefault?.info?.newConfig?.components?.Button
                        ?.primaryColor || "white"
                      : "inherit"};
                    line-height: 1;
                  `}
                  onClick={() => setSelectedSetting(e)}
                >
                  <span
                    className={css`
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      width: 18px;
                      height: 18px;
                      flex-shrink: 0;
                      svg {
                        display: block;
                        width: 100%;
                        height: 100%;
                      }
                    `}
                  >
                    {TabIconArr.find((i) => i.key === e)?.icon}
                  </span>
                  <span
                    className={css`
                      display: flex;
                      align-items: center;
                      line-height: 1;
                    `}
                  >
                    {e}
                  </span>
                </p>
              ))
            );
          })}
        </Card>
      </Col>
      <Col
        span={18}
        className={css`
          .ant-tabs-tabpane {
            padding-block: 16px;
          }
        `}
      >
        {selectedSetting === "Users"
          ? getSelectedUserComponent(selectedUserType)
          : itemsToRender.length === 1
            ? itemsToRender[0].children
            : itemsToRender.length > 1 && (
              <Tabs
                items={itemsToRender}
                defaultActiveKey={itemsToRender[0]?.key}
                style={{ height: "calc( 100vh - 240px )" }}
              />
            )}
      </Col>
    </Row>
  );
}

export default AllSettings;
export const TabIconArr = [
  {
    key: "Entity",
    icon: <Courthouse size="small" />,
  },
  {
    key: "Users",
    icon: <PeopleIcon size="small" />,
  },
  {
    key: "Modules",
    icon: <CustomGridIcon size="small" />,
  },
];
